import React, { useState } from 'react';
import { GuideFormPopup } from './GuideFormPopup';
export const Footer = () => {
  const [showGuidePopup, setShowGuidePopup] = useState(false);
  return <footer className="bg-[#0f1f10] text-white" data-id="element-275">
      {/* Divider */}
      <div className="w-full h-px bg-white/10" data-id="element-276"></div>

      <div className="container mx-auto px-4 md:px-8 py-12 md:py-16" data-id="element-277">
        <div className="max-w-5xl mx-auto" data-id="element-278">
          {/* Logo + tagline */}
          <div className="flex flex-col items-center mb-10" data-id="element-279">
            <img src="https://cdn.magicpatterns.com/uploads/cGmqASMaWsiDkJPn4a1Kiz/logo_w_n_(1).svg" alt="Ikigai Real Estate" className="h-14 md:h-16 mb-4 object-contain" data-id="element-280" />
            <p className="text-white/40 text-sm text-center max-w-md" data-id="element-281">
              Helping global investors enter Dubai's property market with
              curated opportunities and professional guidance.
            </p>
          </div>

          {/* Links row */}
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 mb-10" data-id="element-282">
            <button onClick={() => setShowGuidePopup(true)} className="text-white/50 text-sm hover:text-[#d8a34d] transition-colors" data-id="element-283">
              Investor Guide
            </button>
            <span className="hidden md:inline text-white/20" data-id="element-284">·</span>
            <a href="https://ikigaire.ae" target="_blank" rel="noopener noreferrer" className="text-white/50 text-sm hover:text-[#d8a34d] transition-colors" data-id="element-285">
              ikigaire.ae
            </a>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-white/10 pt-8 text-center" data-id="element-286">
            <p className="text-white/30 text-xs" data-id="element-287">
              © {new Date().getFullYear()} Ikigai Real Estate. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>

      <GuideFormPopup isOpen={showGuidePopup} onClose={() => setShowGuidePopup(false)} data-id="element-288" />
    </footer>;
};